<template>
  <div id="app">
    <router-view id="routerview"/>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
name: 'App',
components:{Footer},
data(){
  return {}
},
methods:{
}
}
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  background-color: whitesmoke;
}

#routerview{
  position: relative;
  min-height: 100vh;
}

.orange{
  background-color: #ff573b !important;
  color: white !important;
}

.orange:hover{
  background-color: #f54729 !important;
  color: white !important;
}

.itsapp_font{
  color: #ff573b !important;
}

.orange:hover{
  background-color: #ff200b;
  color: white !important;
}

.img{
    width: 35px;
    height: 35px;
}

.bandera{
    width: 35px;
    height: 20px;
}

.pointer{
  cursor: pointer;
}

.notLink:hover{
  text-decoration: none;
}

.table{
    background-color: white;
}

.pdf{
  color: #ad0d02;
  font-size: 28px;
}

.warning-font{
  color:red; 
  font-size:12px; 
  line-height:15pt
}

</style>



// WEBPACK FOOTER //
// src/App.vue